var App = App || {};

App.Signin = (function ($) {
	"use strict";

	const MSG_INVALID = "Username or password incorrect.";
	const MSG_ACCOUNT_LOCKED = "Account locked.";
	const MSG_OK = "Signed in successfully.";
	const MSG_BAD_REQUEST = "Bad Request";
	const MSG_SERVER_ERROR = "Server Error";

	function showLoginError($form, $summary, message) {
		$summary.text(message);
		$form.find('input[name="Username"]').trigger("focus");
		$form[0].scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	}

	function getSafeReturnUrl(data) {
		const querystring = new URLSearchParams(window.location.search);
		let returnUrl = querystring.get("returnUrl") || querystring.get("ReturnUrl") || "";

		if (!returnUrl.startsWith("/") || returnUrl.startsWith("//"))
			returnUrl = "";

		if (!returnUrl && typeof data === "string") {
			if (data.trim().startsWith("/") && !data.trim().startsWith("//"))
				returnUrl = data.trim();
		}

		return returnUrl || "/";
	}

	function applyValidationMessages($form) {
		$form.find(":invalid").each(function () {
			let msg = "";

			switch (true) {
				case this.validity.valueMissing:
					msg = $(this).data("val-required") || "A value is required.";
					break;
				case this.validity.typeMismatch:
					msg = $(this).data("val-type") || "Incorrect format.";
					break;
				default:
					msg = this.validationMessage || "";
					break;
			}

			$(this).siblings(".field-validation-error").text(msg);
			
		});
	}

	function init() {
		$(document).on("submit", "form.sign-in-async", function (e) {
			e.preventDefault();

			const $form = $(this);
			const $summary = $form.find(".form-validation-message").empty();
			const $submitBtn = $form.find('button[type="submit"]');

			$form.find("input").each((_, el) => el.setCustomValidity(""));
			$form.addClass("was-validated");

			if (!$form[0].checkValidity()) {
				applyValidationMessages($form);
				return;
			}

			App.Spinner.startSpinner($submitBtn, "Verifying");
			$submitBtn.prop("disabled", true);

			$.ajax({
				type: $form.attr("method") || "POST",
				url: $form.attr("action"),
				cache: false,
				data: $form.serializeArray(),
				statusCode: {
					200: function (data) {
						$summary.text(MSG_OK);
						window.location = getSafeReturnUrl(data);
					},
					401: function () { showLoginError($form, $summary, MSG_INVALID); },
					403: function () { showLoginError($form, $summary, MSG_INVALID); },
					423: function () { showLoginError($form, $summary, MSG_ACCOUNT_LOCKED); },
					404: function () { $summary.text(MSG_BAD_REQUEST); },
					500: function () { $summary.text(MSG_SERVER_ERROR); }
				},
				complete: function (jqXHR) {
					if (jqXHR.status === 200)
						return;

					App.Spinner.stopSpinner($submitBtn);
					$submitBtn.prop("disabled", false);
				}
			});
		});
	}

	return { init: init };
})(jQuery);

$(function () {
	App.Signin.init();
});
